import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { Toast } from 'primereact/toast';
import axios from 'axios';

import { RootState } from '../../../../redux';
import {
  storeUpdateReadStatus,
  installerReviewRead,
  customerNotesReviewRead,
  storeReviewRead,
  installerUpdateReadStatus,
  customerNotesUpdateReadStatus,
  getInstallerNotifications as getInstallerNotificationsLegacy,
  getSMSNotifications as getSMSNotificationsLegacy,
  getEmailNotifications as getEmailNotificationsLegacy,
  getStoreNotifications as getStoreNotificationsLegacy,
  getCustomerNotesNotifications as getCustomerNotesLegacy,
  getCustomerChatsNotifications,
  customerChatUpdateReadStatus,
  customerChatReviewRead,
} from '../../../../components/ProjectManagement/ProjectInfo/ProjectDetails.service';
import {
  AppDispatch,
  CrmEmailListInterface,
  CrmNotesListInterface,
  CRMSMSItemInterface,
  CRMSMSResponseInterface,
  CustomerChatItem,
  CustomerChatsApiResult,
  CustomerChatsList,
  CustomerCRMNotesResponse,
  CustomerNotesListInterface,
  CustomerNotificationsResponse,
  EmailApiItem,
  EmailNotificationsResponse,
  ExtendedEmailApiItem,
  InstallerNotificationInterface,
  InstallerNotificationsResponse,
  NotificationsListInterface,
  SMSNotificationsResponse,
  StoreNotificationListInterface,
  StoreNotificationsResponse,
} from '../interface/app-header';
import {
  checkPermission,
  disabledLoadMore,
  ellipsisString,
  redirectPage,
} from '../../../../utils/Helpers';
import permissions from '../../../../config/permissions';
import { clientDetails, Limit } from '../../../../constants';
import { emailReviewRead } from '../../../ProjectManagement/Notes/components/EmailNotifications/EmailNotifications.service';
import {
  markMessageAsRead,
  markMessageAsReviewed,
} from '../../../ProjectManagement/Notes/components/SMS/SmsNotifications.service';
import { setCallNotification } from '../../../../redux/slices/page-header.slice';
import { Notifications } from '../../../../constants/notification.constant';
import {
  checkCRMPermission,
  getCustomerCommunicationTabs,
  getEmailTabs,
  getInstallerStoreNotesTabs,
  getSMSTabs,
  getSubType,
  mapCRMEmailNotificationsList,
  mapCRMNotes,
  mapCRMSMSNotificationsList,
  mapCustomerNotesList,
} from '../helpers/Topbar.helper';
import {
  crmEmailReviewRead,
  crmNotesReviewRead,
  crmSMSReviewRead,
  getCRMNotes,
  getCustomerNotification,
  getEmailNotifications,
  getInstallerNotifications,
  getSMSNotifications,
  getStoreNotifications,
  syncNotifications,
  updateNotificationViewed,
} from '../Notification/Notification.service';
import {
  REACT_APP_ENABlE_ONLY_FOR_PF_USER,
  REACT_APP_ENABLE_PUSH_NOTIFICATION,
} from '../../../../constants/envConstants';
import { getRandomColorName } from '../helpers/header.helper';

const HeaderNotifications = () => {
  const dispatch: AppDispatch = useDispatch();
  const toast = useRef<Toast | null>(null);
  const [installerNotificationsList, setInstallerNotificationsList] = useState<
    InstallerNotificationInterface[]
  >([]);
  const [storeNotificationsList, setStoreNotificationsList] = useState<
    StoreNotificationListInterface[]
  >([]);
  const [notificationsList, setNotificationsList] = useState<
    NotificationsListInterface[]
  >([]);
  const [crmSMSList, setCRMSMSList] = useState<CRMSMSItemInterface[]>([]);
  const defaultCustomerChatsList: CustomerChatsList = {
    count: 0,
    list: [],
    templateList: [],
    offset: 0,
    limit: Limit.MAX_LIMIT,
    isLoading: false,
  };
  const [customerChatsList, setCustomerChatsList] = useState<CustomerChatsList>(
    defaultCustomerChatsList
  );
  const [customerNotesList, setCustomerNotesList] = useState<
    CustomerNotesListInterface[]
  >([]);
  const [crmNotesList, setCRMNotesList] = useState<CrmNotesListInterface[]>([]);
  const [emailList, setEmailList] = useState<EmailApiItem[]>([]);
  const [crmEmailList, setCRMEmailList] = useState<CrmEmailListInterface[]>([]);
  const [SMSLoading, setSMSLoading] = useState<boolean>(false);

  const [storeLoading, setStoreLoading] = useState<boolean>(false);
  const [installerLoading, setInstallerLoading] = useState<boolean>(false);
  const [emailLoading, setEmailLoading] = useState<boolean>(false);

  const [installerOffset, setInstallerOffset] = useState<number>(0);
  const [storeOffset, setStoreOffset] = useState<number>(0);
  const [smsOffset, setSmsOffset] = useState<number>(0);
  const [emailOffset, setEmailOffset] = useState<number>(0);
  const [crmEmailOffset, setCRMEmailOffset] = useState<number>(0);
  const [crmSMSOffset, setCRMSMSOffset] = useState<number>(0);
  const [crmNoteOffset, setCRMNoteOffset] = useState<number>(0);
  const [customerNoteOffset, setCustomerNoteOffset] = useState<number>(0);
  const isPFUser =
    (JSON.parse(localStorage.getItem('isPFUser') || 'false') as boolean) ??
    false;
  const pushNotificationEnabled: boolean =
    REACT_APP_ENABlE_ONLY_FOR_PF_USER === false
      ? REACT_APP_ENABLE_PUSH_NOTIFICATION
      : isPFUser;

  const [storeCount, setStoreCount] = useState<number>(0);
  const [emailCount, setEmailCount] = useState<number>(0);
  const [smsCount, setSmsCount] = useState<number>(0);
  const [crmEmailCount, setCRMEmailCount] = useState<number>(0);
  const [crmSMSCount, setCRMSMSCount] = useState<number>(0);
  const [crmNotesCount, setCRMNotesCount] = useState<number>(0);
  const [customerNotesCount, setCustomerNotesCount] = useState<number>(0);

  const [totalInstallerNotificationCount, setTotalInstallerNotificationCount] =
    useState<number>(0);

  const [totalInstallercount, setTotalInstallercount] = useState<number>(0);
  const [totalStoreCount, setTotalStoreCount] = useState<number>(0);
  const [totalEmailCount, setTotalEmailCount] = useState<number>(0);
  const [totalSmsCount, setTotalSmsCount] = useState<number>(0);
  const [totalCRMEmailCount, setTotalCRMEmailCount] = useState<number>(0);
  const [totalCRMSMSCount, setTotalCRMSMSCount] = useState<number>(0);
  const [totalCRMNotesCount, setTotalCRMNotesCount] = useState<number>(0);
  const [totalCustomerNotesCount, setTotalCustomerNotesCount] =
    useState<number>(0);

  const { callNotification } = useSelector(
    (state: RootState) => state.pageHeader
  );

  const [syncNotification, setSyncNotification] = useState<boolean>(false);

  const [
    hasCxNotesViewPermission,
    hasCxNotesUpdatePermission,
    hasPullDownMenu,
    hasInstallerVisibilityNotes,
    hasStoreVisibilityNotes,
    hasEmailVisibilityNotes,
    hasSmsVisibilityNotes,
    hasVisibilityCustomerChats,
    hasVisibilityCustomerNotes,
  ] = useMemo(() => {
    return [
      checkPermission(permissions?.customer_notes?.view),
      checkPermission(permissions?.customer_notes?.update),
      checkPermission(permissions?.pullDownMenu?.view),
      checkPermission(permissions?.pullDownMenu?.installerNotes),
      checkPermission(permissions?.pullDownMenu?.storeNotes),
      checkPermission(permissions?.pullDownMenu?.email),
      checkPermission(permissions?.pullDownMenu?.sms),
      checkPermission(permissions?.pullDownMenu?.customerChats) &&
        checkPermission(permissions?.customer_notes?.view),
      checkPermission(permissions?.pullDownMenu?.customerNotes),
    ];
  }, [localStorage.getItem('permissions')]);

  const handleCustomerChatsNotificationClick = (
    project_id: number | string,
    note_id: number | string,
    type: 'review' | 'read'
  ) => {
    if (!hasCxNotesUpdatePermission) return;
    if (type === Notifications.ACTION.Review) {
      customerChatReviewRead(note_id, type, localStorage.getItem('user_id'));
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.CUSTOMER,
          localStorage.getItem('user_id'),
          false,
          true
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
      const updatedNoteList = removeElementByNoteId(
        customerChatsList.list,
        note_id
      );
      reArrangeCustomerChatsList(updatedNoteList, customerChatsList.count);
    } else if (type === Notifications.ACTION.Read) {
      customerChatUpdateReadStatus(
        note_id,
        type,
        localStorage.getItem('user_id')
      );
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.CUSTOMER,
          localStorage.getItem('user_id'),
          true,
          false
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
      const updatedNoteList = setViewStatusByNoteId(
        customerChatsList.list,
        note_id
      );
      reArrangeCustomerChatsList(updatedNoteList, customerChatsList.count);
    }
    redirectPage(
      `/project/view/${project_id}/#tab=communications&subtab=customerChats`
    );
  };

  const loadMoreCustomerChatsHandler = (): void => {
    let newOffset = 0;
    setCustomerChatsList((prev: CustomerChatsList) => {
      newOffset = prev?.offset + Limit?.MAX_LIMIT;
      return {
        ...prev,
        isLoading: true,
        offset: newOffset,
      };
    });
    if (newOffset < 100) {
      callGetCustomerChatsNotification(newOffset, Limit?.MAX_LIMIT);
    } else {
      getCustomerChatsNotifications(newOffset, Limit?.MAX_LIMIT).then(res => {
        if (
          res?.data?.count &&
          Array.isArray(res?.data?.items) &&
          res?.data?.items.length
        ) {
          reArrangeCustomerChatsList(
            res?.data?.items,
            res?.data.count,
            newOffset,
            Limit?.MAX_LIMIT
          );
        }
      });
    }
  };

  const renderCustomerChatsTemplate = (
    isEmpty: boolean,
    source: string,
    id: number | string,
    from: string,
    customer: string,
    message: string,
    is_read: number | boolean,
    project_id: number | string,
    index: number,
    length: number,
    total?: number
  ) => {
    return isEmpty ? (
      <div
        className="flex px-2 py-2 align-items-center"
        key={'notify_' + source + '_' + id}
      >
        <div className="px-3 text-xs">
          <strong>No new notifications</strong>
        </div>
      </div>
    ) : (
      <>
        <div
          className={`px-2 pt-1 pb-1 align-items-center w-12 border-bottom-1 border-200 ${
            is_read ? 'bg-white' : 'surface-50'
          }`}
          key={'notify_' + source + '_' + id}
        >
          <div className="grid m-0">
            <div className="col-8 flex text-xs pl-0 align-items-center">
              <i className="pi pi-user mr-2 text-xs"></i>
              <strong>CX Name: {customer}</strong>
            </div>
            {hasCxNotesUpdatePermission && (
              <div className="col-4 flex p-0 w-0 justify-content-end align-items-center">
                <Button
                  onClick={() =>
                    handleCustomerChatsNotificationClick(
                      project_id,
                      id,
                      'review'
                    )
                  }
                  outlined
                  label="Review"
                  className="text-xs p-1 focus:shadow-none"
                />
                <Button
                  onClick={() =>
                    handleCustomerChatsNotificationClick(project_id, id, 'read')
                  }
                  label="View"
                  className="text-xs p-1 focus:shadow-none ml-2"
                />
              </div>
            )}
          </div>
          <div className="text-xs col-12 p-0 pr-2">
            <i className="pi pi-send mr-2 text-xs"></i>
            {ellipsisString(message, 45)}
          </div>
        </div>
        {index == length - 1 && (
          <div className="block  flex justify-content-center surface-200 p-2">
            <Button
              size="small"
              outlined
              severity="info"
              className="py-1 px-2"
              disabled={length === total}
              onClick={loadMoreCustomerChatsHandler}
            >
              Load more
              {customerChatsList.isLoading ? (
                <i className="pi pi-spin pi-spinner ml-2 text-10"></i>
              ) : (
                ''
              )}
            </Button>
          </div>
        )}
      </>
    );
  };

  const createCustomerChatsTemplate = (
    newData: CustomerChatItem[],
    oldData: CustomerChatItem[],
    total: number
  ): Array<
    { template: () => React.ReactElement } | { icon: string; label: string }
  > => {
    const data = [...oldData, ...newData];
    return data.map((row: CustomerChatItem, index: number) => {
      return {
        template: () => {
          return renderCustomerChatsTemplate(
            false,
            'customer_note',
            row?.note_id ?? '',
            row?.name ?? '',
            `${row?.customer_first_name ?? ''} ${row?.customer_last_name ?? ''}`,
            row?.note ?? '',
            row?.is_read ?? 0,
            row?.project_id ?? 0,
            index,
            data.length,
            total
          );
        },
      };
    });
  };

  const reArrangeCustomerChatsList = (
    list: CustomerChatItem[],
    total: number,
    offset?: number,
    limit?: number
  ) => {
    const itemsLength = customerChatsList.list?.length + list?.length;

    setCustomerChatsList(prev => {
      const data = itemsLength
        ? createCustomerChatsTemplate(list, prev.list, total)
        : [
            {
              icon: 'pi pi-search',
              label: 'No result found',
            },
          ];

      return {
        ...prev,
        count: total,
        templateList: data,
        list: [...prev.list, ...list],
        limit: limit ?? prev.limit,
        isLoading: false,
      };
    });
  };

  const callGetCustomerChatsNotification = async (
    offset: number,
    limit: number
  ) => {
    if (hasVisibilityCustomerChats) {
      let result: CustomerChatsApiResult = { data: { items: [], count: 0 } };
      if (offset < 100) {
        const res = await getCustomerNotification(offset, Limit?.MAX_LIMIT, [
          0,
        ]);
        result.data.items = res?.customerComms ?? [];
        result.data.count = res?.count ?? 0;
      } else {
        result = await getCustomerChatsNotifications(offset, Limit?.MAX_LIMIT);
      }
      if (
        result?.data?.count &&
        Array.isArray(result?.data?.items) &&
        result?.data?.items.length
      ) {
        reArrangeCustomerChatsList(
          result.data.items,
          result.data.count,
          offset,
          limit
        );
      }
    }
  };

  const getNotificationData = async (): Promise<void> => {
    setInstallerOffset(0);
    setStoreOffset(0);
    setEmailOffset(0);
    setSmsOffset(0);
    setCRMSMSOffset(0);
    setCRMEmailOffset(0);
    setCRMNoteOffset(0);
    setCustomerNoteOffset(0);
    setCustomerChatsList(defaultCustomerChatsList);
    setInstallerLoading(true);
    const crmPermission = checkCRMPermission();
    if (hasInstallerVisibilityNotes) {
      getInstallerNotifications(0, Limit.MAX_LIMIT, [0]).then(
        (res: InstallerNotificationsResponse | undefined) => {
          if (!res) return;
          setInstallerNotificationsList(res.installerList);
          setTotalInstallerNotificationCount(res.count);
        }
      );
      setInstallerLoading(false);
    }
    if (hasStoreVisibilityNotes) {
      setStoreLoading(true);
      getStoreNotifications(0, Limit.MAX_LIMIT, [0]).then(
        (res: StoreNotificationsResponse | undefined) => {
          if (!res) return;
          setStoreNotificationsList(res.storeList);
          setStoreCount(res.count);
          setStoreLoading(false);
        }
      );
    }
    if (hasSmsVisibilityNotes) {
      setSMSLoading(true);
      getSMSNotifications(0, Limit.MAX_LIMIT, [0]).then(
        (res: SMSNotificationsResponse | undefined) => {
          if (!res) return;
          setNotificationsList(res.data);
          setSmsCount(res.count);
          setSMSLoading(false);
        }
      );
    }
    if (crmPermission) {
      setSMSLoading(true);
      getSMSNotifications(0, Limit.MAX_LIMIT, [1, 2, 3, 4, 5]).then(
        (res: CRMSMSResponseInterface | undefined) => {
          if (!res) return;
          setCRMSMSList(res.data);
          setTotalCRMSMSCount(res.count ?? 0);
          setCRMSMSCount(res?.data?.length);
          setSMSLoading(false);
        }
      );
    }
    if (hasEmailVisibilityNotes) {
      setEmailLoading(true);
      getEmailNotifications(0, Limit.MAX_LIMIT, [0]).then(
        (res: EmailNotificationsResponse | undefined) => {
          if (!res) return;
          setEmailList(res.emailList);
          setEmailCount(res.count);
          setEmailLoading(false);
        }
      );
    }
    if (crmPermission) {
      setEmailLoading(true);
      getEmailNotifications(0, Limit.MAX_LIMIT, [1, 2, 3, 4, 5]).then(
        (res: EmailNotificationsResponse | undefined) => {
          if (!res) return;

          const transformed: CrmEmailListInterface[] = (
            res.emailList || []
          )?.map((item: EmailApiItem, index: number, arr: EmailApiItem[]) => {
            const e = item as ExtendedEmailApiItem;
            return {
              isEmpty: false,
              source: 'crm_email',
              client_id: e.client_id,
              fromName: e.LastEmail?.from?.[0]?.name ?? null,
              toName:
                `${e.customer_first_name ?? ''} ${e.customer_last_name ?? ''}`.trim(),
              subject: e.subject,
              total_email: e.total_email,
              project_id: e.project_id,
              id: e.id,
              message_id: e.id,
              is_read: (e.LastEmail?.read ?? 0) as number | boolean,
              index,
              length: arr.length,
              customer_id: e.customer_id,
              opportunity_id: e.opportunity_id,
              quote_id: e.quote_id,
              invoice_id: e.invoice_id,
              payment_id: e.payment_id,
            };
          });

          setCRMEmailList(transformed);
          setCRMEmailCount(transformed.length);
          setTotalCRMEmailCount(res.count ?? 0);
          setEmailLoading(false);
        }
      );
    }
    if (hasCxNotesViewPermission && clientDetails?.is_customer_portal === 1) {
      getCustomerNotification(0, Limit.MAX_LIMIT, [0]).then(
        (res: CustomerNotificationsResponse | undefined) => {
          reArrangeCustomerChatsList(
            res?.customerComms ?? [],
            res?.count ?? 0,
            0,
            Limit.MAX_LIMIT
          );
        }
      );
    }
    if (hasVisibilityCustomerNotes) {
      getCustomerNotification(0, Limit.MAX_LIMIT, [6]).then(
        (res: CustomerNotificationsResponse | undefined) => {
          if (!res) return;
          setCustomerNotesList(res.customerComms ?? []);
          setCustomerNotesCount(res.customerComms?.length ?? 0);
          setTotalCustomerNotesCount(res?.count ?? 0);
        }
      );
    }
    if (crmPermission) {
      getCRMNotes(0, Limit.MAX_LIMIT, [1, 2, 3, 4, 5]).then(
        (res: { data: CrmNotesListInterface[]; count: number } | undefined) => {
          if (!res) return;

          setCRMNotesList(res.data);
          setTotalCRMNotesCount(res.count ?? 0);
          setCRMNotesCount(res?.data?.length);
        }
      );
    }
  };

  const fetchNotification = (): void => {
    getNotificationData();
  };

  const fetchUserProfile = async (): Promise<void> => {
    if (axios.defaults.headers.common['client-id']) {
      fetchNotification();
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, [axios.defaults.headers.common['client-id']]);

  useEffect(() => {
    if (callNotification === true) {
      fetchNotification();
      dispatch(setCallNotification(false));
    }
  }, [callNotification]);

  const installerNotificationsLength = totalInstallerNotificationCount;

  const removeElementByNoteId = <
    T extends { note_id?: number | string; id?: number | string },
  >(
    arr: T[],
    note_id: number | string
  ): T[] => {
    return arr?.filter(
      item => item?.note_id !== note_id && item?.id !== note_id
    );
  };

  const setViewStatusByNoteId = <
    T extends {
      note_id?: number | string;
      id?: number | string;
      is_read?: number | boolean;
    },
  >(
    arr: T[],
    note_id: number | string
  ): T[] => {
    return arr?.map(item => {
      if (item?.note_id === note_id || item?.id === note_id) {
        item.is_read = 1;
      }
      return item;
    });
  };

  const handleInstallerNotificationClick = (
    project_id: number | string,
    note_id: number | string,
    type: 'review' | 'read'
  ) => {
    if (type === 'review') {
      installerReviewRead(note_id, type, localStorage.getItem('user_id'));
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.INSTALLER,
          localStorage.getItem('user_id'),
          false,
          true
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
      setInstallerNotificationsList(
        removeElementByNoteId(installerNotificationsList, note_id)
      );
    } else if (type === 'read') {
      installerUpdateReadStatus(note_id, type, localStorage.getItem('user_id'));
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.INSTALLER,
          localStorage.getItem('user_id'),
          true,
          false
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
      setInstallerNotificationsList(
        setViewStatusByNoteId(installerNotificationsList, note_id)
      );
    }
    redirectPage(
      `/project/view/${project_id}/#tab=communications&subtab=notes`
    );
  };

  const handleCustomerNotesClick = (
    project_id: number | string,
    note_id: number | string,
    type: 'review' | 'read'
  ) => {
    if (type === 'review') {
      customerNotesReviewRead(note_id, type, localStorage.getItem('user_id'));
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.CUSTOMER,
          localStorage.getItem('user_id'),
          false,
          true,
          [6]
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
      setCustomerNotesList(removeElementByNoteId(customerNotesList, note_id));
    } else if (type === 'read') {
      customerNotesUpdateReadStatus(
        note_id,
        type,
        localStorage.getItem('user_id')
      );
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.CUSTOMER,
          localStorage.getItem('user_id'),
          true,
          false,
          [6]
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
      setCustomerNotesList(setViewStatusByNoteId(customerNotesList, note_id));
    }
    redirectPage(
      `/project/view/${project_id}/#tab=communications&subtab=notes`
    );
  };

  const handleCRMNotesClick = (
    customer_id: number | string,
    note_id: number | string,
    type: 'review' | 'read'
  ) => {
    const crmNote =
      Array.isArray(crmNotesList) &&
      crmNotesList?.find(
        (note: CrmNotesListInterface) =>
          note.id ?? note.customerNotesId === note_id
      );
    if (!crmNote) return;
    const subType = getSubType(crmNote);
    if (type === 'review') {
      crmNotesReviewRead(customer_id, note_id, type);
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.CUSTOMER,
          localStorage.getItem('user_id'),
          false,
          true,
          [subType]
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
    } else if (type === 'read') {
      crmNotesReviewRead(customer_id, note_id, type);
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.CUSTOMER,
          localStorage.getItem('user_id'),
          true,
          false,
          [subType]
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
    }
    const { opportunity_id, quote_id, invoice_id } = crmNote;
    const redirectPageLink: Record<number, string> = {
      1: `/crm/view/customer/${customer_id}?tab=notes`,
      2: `/crm/${customer_id}/opportunity/view/${opportunity_id}?tab=notes`,
      3: `/crm/${customer_id}/${opportunity_id}/quote/view/${quote_id}?tab=notes`,
      4: `/crm/invoice/view/${invoice_id}?tab=notes`,
    };

    redirectPage(redirectPageLink[subType]);
  };

  const handleCRMSMSClick = (
    note_id: number | string,
    type: 'review' | 'read'
  ) => {
    const crmSMS =
      Array.isArray(crmSMSList) &&
      crmSMSList?.find(
        (sms: CRMSMSItemInterface) => sms.sms_response_log_id === note_id
      );
    if (type === 'review') {
      crmSMSReviewRead(note_id, type);
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.SMS,
          localStorage.getItem('user_id'),
          false,
          true,
          [1, 2, 3, 4, 5]
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
    } else if (type === 'read') {
      crmSMSReviewRead(note_id, type);
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.CUSTOMER,
          localStorage.getItem('user_id'),
          true,
          false,
          [1, 2, 3, 4, 5]
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
    }
    if (!crmSMS) return;
    const subType = getSubType(crmSMS);
    const { customer_id, opportunity_id, quote_id, invoice_id } = crmSMS;

    const redirectPageLink: Record<number, string> = {
      1: `/crm/view/customer/${customer_id}?tab=sms`,
      2: `/crm/${customer_id}/opportunity/view/${opportunity_id}?tab=sms`,
      3: `/crm/${customer_id}/${opportunity_id}/quote/view/${quote_id}?tab=sms`,
      4: `/crm/invoice/view/${invoice_id}?tab=sms`,
    };

    redirectPage(redirectPageLink[subType]);
  };

  const handleCRMEmailClick = (
    note_id: number | string,
    type: 'review' | 'read'
  ) => {
    const crmEmail =
      Array.isArray(crmEmailList) &&
      crmEmailList?.find(
        (email: CrmEmailListInterface) => email.id === note_id
      );

    if (type === 'review') {
      crmEmailReviewRead(note_id, type);
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.EMAIL,
          localStorage.getItem('user_id'),
          false,
          true,
          [1, 2, 3, 4, 5]
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
    } else if (type === 'read') {
      crmEmailReviewRead(note_id, type);
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.EMAIL,
          localStorage.getItem('user_id'),
          true,
          false,
          [1, 2, 3, 4, 5]
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
    }
    if (!crmEmail) return;
    const subType = getSubType(crmEmail);
    const { customer_id, opportunity_id, quote_id, invoice_id } = crmEmail;
    const redirectPageLink: Record<number, string> = {
      1: `/crm/view/customer/${customer_id}?tab=email`,
      2: `/crm/${customer_id}/opportunity/view/${opportunity_id}?tab=email`,
      3: `/crm/${customer_id}/${opportunity_id}/quote/view/${quote_id}?tab=email`,
      4: `/crm/invoice/view/${invoice_id}?tab=email`,
    };

    redirectPage(redirectPageLink[subType]);
  };

  const handleStoreNotificationClick = (
    project_id: number | string,
    note_id: number | string,
    type: 'review' | 'read'
  ) => {
    if (type === 'review') {
      storeReviewRead(note_id, type, localStorage.getItem('user_id'));
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.STORE,
          localStorage.getItem('user_id'),
          false,
          true
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
      setStoreNotificationsList(
        removeElementByNoteId(storeNotificationsList, note_id)
      );
    } else if (type === 'read') {
      storeUpdateReadStatus(note_id, type, localStorage.getItem('user_id'));
      if (pushNotificationEnabled === true) {
        updateNotificationViewed(
          note_id,
          Notifications.STORE,
          localStorage.getItem('user_id'),
          true,
          false
        ).then(() => {
          dispatch(setCallNotification(true));
        });
      }
      setStoreNotificationsList(
        setViewStatusByNoteId(storeNotificationsList, note_id)
      );
    }
    redirectPage(
      `/project/view/${project_id}/#tab=communications&subtab=notes`
    );
  };

  const handleNotificationClick = async (
    project_id: number | string,
    sms_response_log_id: number | string
  ) => {
    await markMessageAsRead(sms_response_log_id, false);
    dispatch(setCallNotification(true));
    redirectPage(`/project/view/${project_id}/#tab=communications&subtab=sms`);
  };

  const handleNotificationClickReview = async (
    project_id: number | string,
    sms_response_log_id: number | string
  ) => {
    await markMessageAsReviewed(sms_response_log_id);
    dispatch(setCallNotification(true));
    redirectPage(`/project/view/${project_id}/#tab=communications&subtab=sms`);
  };

  const handleEmailNotificationOnReview = async (
    project_id: number | string,
    message_id: number | string
  ) => {
    await emailReviewRead(message_id, 'review');
    dispatch(setCallNotification(true));
    redirectPage(
      `/project/view/${project_id}/#tab=communications&subtab=email`
    );
  };

  const handleEmailNotificationClick = async (
    project_id: number | string,
    message_id: number | string
  ) => {
    await emailReviewRead(message_id, 'read');
    dispatch(setCallNotification(true));
    redirectPage(
      `/project/view/${project_id}/#tab=communications&subtab=email`
    );
  };

  const loadMoreInstallerHandler = (): void => {
    setTotalInstallercount(totalInstallercount + 1);
    const newOffset = installerOffset + Limit?.MAX_LIMIT;
    if (newOffset < 100) {
      setInstallerLoading(true);
      getInstallerNotifications(newOffset, Limit?.MAX_LIMIT, [0]).then(
        (res: InstallerNotificationsResponse | undefined) => {
          if (!res) return;
          setInstallerNotificationsList([
            ...installerNotificationsList,
            ...res.installerList,
          ]);
          setTotalInstallerNotificationCount(res.count);
          setInstallerLoading(false);
        }
      );
    } else {
      getInstallerNotificationsLegacy(
        setInstallerLoading,
        setInstallerNotificationsList,
        newOffset,
        Limit?.MAX_LIMIT,
        installerNotificationsList,
        () => {},
        setTotalInstallerNotificationCount
      );
    }
    setInstallerOffset(newOffset);
  };

  const loadMoreStoreHandler = (): void => {
    setTotalStoreCount(totalStoreCount + 1);
    const newOffset = storeOffset + Limit?.MAX_LIMIT;
    if (newOffset < 100) {
      setStoreLoading(true);

      getStoreNotifications(newOffset, Limit?.MAX_LIMIT, [0]).then(
        (res: StoreNotificationsResponse | undefined) => {
          if (!res) return;
          setStoreNotificationsList([
            ...storeNotificationsList,
            ...res.storeList,
          ]);
          setStoreCount(res.count);
          setStoreLoading(false);
        }
      );
    } else {
      getStoreNotificationsLegacy(
        setStoreLoading,
        setStoreNotificationsList,
        newOffset,
        Limit?.MAX_LIMIT,
        setStoreCount
      );
    }
    setStoreOffset(newOffset);
  };

  const loadMoreEmailHandler = (): void => {
    setTotalEmailCount(totalEmailCount + 1);
    const newOffset = emailOffset + Limit?.MAX_LIMIT;
    if (newOffset < 100) {
      setEmailLoading(true);

      getEmailNotifications(newOffset, Limit?.MAX_LIMIT, [0]).then(
        (res: EmailNotificationsResponse | undefined) => {
          if (!res) return;
          setEmailList([...emailList, ...res.emailList]);
          setEmailCount(res.count);
          setEmailLoading(false);
        }
      );
    } else {
      getEmailNotificationsLegacy(
        setEmailLoading,
        setEmailList,
        newOffset,
        Limit?.MAX_LIMIT,
        setEmailCount
      );
    }
    setEmailOffset(newOffset);
  };

  const loadMoreCRMEmailHandler = (): void => {
    const newOffset = crmEmailOffset + Limit?.MAX_LIMIT;
    if (newOffset < 100) {
      setEmailLoading(true);
      getEmailNotifications(newOffset, Limit?.MAX_LIMIT, [1, 2, 3, 4, 5]).then(
        (res: EmailNotificationsResponse | undefined) => {
          const emails = res?.emailList ?? [];
          setCRMEmailList(prev => {
            const transformed: CrmEmailListInterface[] = emails?.map(
              (item: EmailApiItem, index: number) => {
                const e = item as ExtendedEmailApiItem;
                return {
                  isEmpty: false,
                  source: 'crm_email',
                  client_id: e?.client_id,
                  fromName: e?.LastEmail?.from?.[0]?.name ?? null,
                  toName:
                    `${e?.customer_first_name ?? ''} ${e?.customer_last_name ?? ''}`.trim(),
                  subject: e?.subject,
                  total_email: e?.total_email,
                  project_id: e?.project_id,
                  id: e?.id,
                  message_id: e?.id,
                  is_read: (e?.LastEmail?.read ?? 0) as number | boolean,
                  index: prev.length + index,
                  length: prev.length + emails.length,
                  customer_id: e?.customer_id,
                  opportunity_id: e?.opportunity_id,
                  quote_id: e?.quote_id,
                  invoice_id: e?.invoice_id,
                  payment_id: e?.payment_id,
                };
              }
            );
            return [...prev, ...transformed];
          });

          setCRMEmailCount(prev => prev + emails.length);
          setEmailLoading(false);
        }
      );
    } else {
      getEmailNotificationsLegacy(
        setEmailLoading,
        setCRMEmailList,
        newOffset,
        Limit?.MAX_LIMIT,
        setCRMEmailCount
      );
    }
    setCRMEmailOffset(newOffset);
  };

  const loadMoreSmsHandler = (): void => {
    setTotalSmsCount(totalSmsCount + 1);
    const newOffset = smsOffset + Limit?.MAX_LIMIT;
    if (newOffset < 100) {
      getSMSNotifications(newOffset, Limit?.MAX_LIMIT, [0]).then(
        (res: SMSNotificationsResponse | undefined) => {
          if (!res) return;
          setNotificationsList([...notificationsList, ...res.data]);
          setSmsCount(res.count);
        }
      );
    } else {
      getSMSNotificationsLegacy(
        setSMSLoading,
        setNotificationsList,
        newOffset,
        Limit?.MAX_LIMIT,
        setSmsCount
      );
    }
    setSmsOffset(newOffset);
  };

  const loadMoreCRMSmsHandler = (): void => {
    const newOffset = crmSMSOffset + Limit?.MAX_LIMIT;
    if (newOffset < 100) {
      getSMSNotifications(newOffset, Limit?.MAX_LIMIT, [1, 2, 3, 4, 5]).then(
        (res: CRMSMSResponseInterface | undefined) => {
          if (!res) return;
          setCRMSMSList([...crmSMSList, ...res.data]);
          setCRMSMSCount(prev => prev + res?.data?.length);
        }
      );
    } else {
      getSMSNotificationsLegacy(
        setSMSLoading,
        setCRMSMSList,
        newOffset,
        Limit?.MAX_LIMIT,
        setCRMSMSCount
      );
    }
    setCRMSMSOffset(newOffset);
  };

  const handleCustomerCommunicationLoading = (value?: boolean) => {
    setCustomerChatsList((prev: CustomerChatsList) => {
      return { ...prev, isLoading: value ?? !customerChatsList?.isLoading };
    });
  };

  const loadMoreCRMNotesHandler = (): void => {
    handleCustomerCommunicationLoading(true);
    const newOffset = crmNoteOffset + Limit?.MAX_LIMIT;
    if (newOffset < 100) {
      setInstallerLoading(true);
      getCustomerNotification(newOffset, Limit.MAX_LIMIT, [1, 2, 3, 4, 5]).then(
        (res: CustomerCRMNotesResponse | undefined) => {
          if (!res) return;

          setCRMNotesList(prev => [...prev, ...res.customerComms]);
          setCRMNotesCount(prev => prev + res.customerComms.length);
          handleCustomerCommunicationLoading(false);
        }
      );
    } else {
      getInstallerNotificationsLegacy(
        setInstallerLoading,
        setInstallerNotificationsList,
        newOffset,
        Limit?.MAX_LIMIT,
        installerNotificationsList,
        () => {},
        setTotalInstallerNotificationCount
      );
    }
    setCRMNoteOffset(newOffset);
    handleCustomerCommunicationLoading(false);
  };

  const loadMoreCustomerNotesHandler = (): void => {
    setCustomerNotesCount(customerNotesCount + 1);
    const newOffset = customerNoteOffset + Limit?.MAX_LIMIT;
    if (newOffset < 100) {
      setCustomerChatsList(prev => {
        return { ...prev, isLoading: true };
      });

      getCustomerNotification(newOffset, Limit.MAX_LIMIT, [6]).then(
        (res: CustomerNotificationsResponse | undefined) => {
          if (!res) return;

          setCustomerNotesList(prev => [...prev, ...res.customerComms]);
          setCustomerNotesCount(prev => prev + res.customerComms.length);
          handleCustomerCommunicationLoading();
        }
      );
    } else {
      getCustomerNotesLegacy(
        setInstallerLoading,
        setInstallerNotificationsList,
        newOffset,
        Limit?.MAX_LIMIT,
        installerNotificationsList,
        () => {}
      );
    }
    setCustomerNoteOffset(newOffset);
  };

  const mapInstallerNotifications = () => {
    const data =
      installerNotificationsList && installerNotificationsList?.length > 0
        ? installerNotificationsList?.map(
            (row: InstallerNotificationInterface, index: number) => {
              return {
                template: () => {
                  return renderInstallerStoreTemplate(
                    false,
                    'store',
                    row?.note_id,
                    row?.name,
                    `${row?.customer_first_name} ${row?.customer_last_name}`,
                    row?.note,
                    row?.is_read,
                    row?.project_id,
                    index,
                    installerNotificationsList?.length
                  );
                },
              };
            }
          )
        : [
            {
              icon: 'pi pi-search',
              label: 'No result found',
            },
          ];
    return data;
  };

  const renderInstallerStoreTemplate = (
    isEmpty: boolean,
    source: string,
    id: number | string,
    from: string,
    customer: string | null,
    message: string,
    is_read: number | boolean,
    project_id: number | string,
    index: number,
    length: number
  ) => {
    return isEmpty ? (
      <div
        className="flex px-3 py-2 align-items-center"
        key={'notify_' + source + '_' + id}
      >
        <div className="px-3 text-xs">
          <strong>No new notifications</strong>
        </div>
      </div>
    ) : (
      <>
        <div
          className={`grid grid-nogutter p-2 align-items-center w-12 relative border-bottom-1 border-200 ${
            Number(is_read) ? 'bg-white' : 'surface-50'
          }`}
          key={'notify_' + source + '_' + id}
        >
          <Badge className={`absolute bg-${getRandomColorName()}-600`}></Badge>
          <div className="col-7 py-0 pl-3 pr-1 text-xs capitalize">
            {from !== 'null null' && (
              <span className="font-bold">Sent From: {from}</span>
            )}

            {customer !== null && <p className="m-0">Cust. Name: {customer}</p>}
          </div>
          <div className="col-5 pl-0 flex justify-content-end">
            <Button
              onClick={() =>
                handleInstallerNotificationClick(project_id, id, 'review')
              }
              label="Review"
              outlined
              className="text-xs p-1 focus:shadow-none"
            />
            <Button
              onClick={() =>
                handleInstallerNotificationClick(project_id, id, 'read')
              }
              label="View"
              className="text-xs p-1 focus:shadow-none ml-2"
            />
          </div>
        </div>
        <div
          className={`${
            index == length - 1
              ? 'block  flex justify-content-center surface-200 p-2'
              : 'hidden'
          }`}
        >
          <Button
            size="small"
            outlined
            severity="info"
            className="py-1 px-2"
            onClick={loadMoreInstallerHandler}
            disabled={
              disabledLoadMore(totalInstallerNotificationCount) ==
                totalInstallercount || installerLoading
            }
          >
            Load more
            {installerLoading ? (
              <i className="pi pi-spin pi-spinner ml-2 text-10"></i>
            ) : (
              ''
            )}
          </Button>
        </div>
      </>
    );
  };

  const mapStoreNotificationsList = () => {
    const data =
      storeNotificationsList && storeNotificationsList?.length > 0
        ? storeNotificationsList?.map(
            (row: StoreNotificationListInterface, index: number) => {
              return {
                template: () => {
                  return renderStoreTemplate(
                    false,
                    'store',
                    row?.note_id,
                    row?.name,
                    `${row?.customer_first_name} ${row?.customer_last_name}`,
                    row?.note,
                    row?.is_read,
                    row?.project_id,
                    index,
                    storeNotificationsList?.length
                  );
                },
              };
            }
          )
        : [
            {
              icon: 'pi pi-search',
              label: 'No result found',
            },
          ];
    return data;
  };

  const renderStoreTemplate = (
    isEmpty: boolean,
    source: string,
    id: number | string,
    from: string,
    customer: string | null,
    message: string,
    is_read: number | boolean,
    project_id: number | string,
    index: number,
    length: number
  ) => {
    return isEmpty ? (
      <div
        className="flex px-3 py-2 align-items-center"
        key={'notify_' + source + '_' + id}
      >
        <div className="px-3 text-xs">
          <strong>No new notifications</strong>
        </div>
      </div>
    ) : (
      <>
        <div
          className={`flex p-2 align-items-center w-12 ${
            Number(is_read) ? 'bg-white' : 'surface-50'
          }`}
          key={'notify_' + source + '_' + id}
        >
          <div className="text-xs col-8 p-0 pr-2 capitalize">
            {from !== 'null null' ? (
              <>
                <i className="pi pi-send mr-2 text-xs"></i>
                <strong>Sent From: {from}</strong>
              </>
            ) : (
              ''
            )}

            {customer !== null ? (
              <>
                <p className="mb-0 mt-1">
                  <i className="pi pi-user mr-2 text-xs"></i>Cust. Name:{' '}
                  {customer}
                </p>
              </>
            ) : (
              ''
            )}
          </div>
          <div className="flex col-4 pl-0 justify-content-end">
            <Button
              onClick={() =>
                handleStoreNotificationClick(project_id, id, 'review')
              }
              label="Review"
              outlined
              className="text-xs p-1 focus:shadow-none"
            />
            <Button
              onClick={() =>
                handleStoreNotificationClick(project_id, id, 'read')
              }
              label="View"
              className="text-xs p-1 focus:shadow-none ml-2"
            />
          </div>
        </div>
        <div
          className={`${
            index == length - 1
              ? 'block  flex justify-content-center surface-200 p-2'
              : 'hidden'
          }`}
        >
          <Button
            size="small"
            outlined
            severity="info"
            className="py-1 px-2"
            onClick={loadMoreStoreHandler}
            disabled={
              disabledLoadMore(storeCount) == totalStoreCount || storeLoading
            }
          >
            Load more
            {storeLoading ? (
              <i className="pi pi-spin pi-spinner ml-2 text-10"></i>
            ) : (
              ''
            )}
          </Button>
        </div>
      </>
    );
  };

  const mapEmailNotificationsList = () => {
    const data =
      emailList && emailList?.length > 0
        ? emailList?.map((row: EmailApiItem, index: number) => {
            return {
              template: () => {
                return renderEmailTemplate(
                  false,
                  'email',
                  row?.client_id,
                  row?.LastEmail?.from?.[0]?.name ?? '',
                  `${row?.customer_first_name} ${row?.customer_last_name}`,
                  row?.subject,
                  row?.total_email,
                  row?.project_id,
                  row?.id,
                  row?.LastEmail?.read ?? 0,
                  index,
                  emailList?.length
                );
              },
            };
          })
        : [
            {
              icon: 'pi pi-search',
              label: 'No email found',
            },
          ];
    return data;
  };

  const renderEmailTemplate = (
    isEmpty: boolean,
    source: string,
    id: number | string,
    fromName: string,
    toName: string,
    subject: string | null,
    total_email: number,
    project_id: number | string,
    message_id: number | string,
    is_read: number | boolean,
    index: number,
    length: number
  ) => {
    return isEmpty ? (
      <div
        className="flex px-3 py-2 align-items-center"
        key={'notify_' + source + '_' + id}
      >
        <div className="px-3 text-xs">
          <strong>No new notifications</strong>
        </div>
      </div>
    ) : (
      <>
        <div
          className={`grid grid-nogutter flex p-2 align-items-center w-12 ${
            Number(is_read) ? 'bg-white' : 'surface-50'
          }`}
          key={'notify_' + source + '_' + id}
        >
          <Badge
            className="relative col-auto ml-1"
            value={total_email ? total_email : '0'}
            severity="secondary"
          ></Badge>
          <div className="col-7 text-xs px-2 capitalize">
            {fromName !== 'null null' && (
              <span className="font-bold">Sent From: {fromName}</span>
            )}

            {toName !== 'null null' && <p className="mb-0 mt-1">{toName}</p>}
          </div>
          <div className="col-auto px-0 text-right">
            <Button
              onClick={() =>
                handleEmailNotificationOnReview(project_id, message_id)
              }
              label="Review"
              outlined
              className="text-xs p-1 focus:shadow-none"
            />
            <Button
              onClick={() =>
                handleEmailNotificationClick(project_id, message_id)
              }
              label="View"
              className="text-xs p-1 focus:shadow-none ml-1"
            />
          </div>
        </div>
        <div
          className={`${
            index == length - 1
              ? 'block  flex justify-content-center surface-200 p-2'
              : 'hidden'
          }`}
        >
          <Button
            size="small"
            outlined
            severity="info"
            className="py-1 px-2"
            onClick={loadMoreEmailHandler}
            disabled={
              disabledLoadMore(emailCount) == totalEmailCount || emailLoading
            }
          >
            Load more
            {emailLoading && (
              <i className="pi pi-spin pi-spinner ml-2 text-10"></i>
            )}
          </Button>
        </div>
      </>
    );
  };

  const getNoResultFoundItem = () => ({
    icon: 'pi pi-search',
    label: 'No result found',
    className: 'pl-3',
  });

  const mapSmsNotificationsList = () => {
    if (!notificationsList || notificationsList.length === 0) {
      return [getNoResultFoundItem()];
    }

    return notificationsList?.map(
      (row: NotificationsListInterface, index: number) => ({
        template: () =>
          renderSmsTemplate(
            false,
            'sms',
            row?.client_id,
            row?.customer_first_name,
            row?.customer_last_name,
            row?.subject,
            row?.project_id,
            row?.sms_response_log_id,
            row?.is_read,
            row?.response_message,
            index,
            notificationsList.length
          ),
      })
    );
  };

  const renderSmsTemplate = (
    isEmpty: boolean,
    source: string,
    client_id: number | string,
    customer_first_name: string,
    customer_last_name: string,
    subject: string | null,
    project_id: number | string,
    sms_response_log_id: number | string,
    is_read: number | boolean,
    response_message: string,
    index: number,
    length: number
  ) => {
    return isEmpty ? (
      <div
        className="flex px-3 py-2 align-items-center"
        key={'notify_' + source + '_' + client_id}
      >
        <div className="px-3 text-xs">
          <strong>No new notifications</strong>
        </div>
      </div>
    ) : (
      <>
        <div
          className={`px-2 pt-1 pb-1 align-items-center w-12 border-bottom-1 border-200 ${
            Number(is_read) ? 'bg-white' : 'surface-50'
          }`}
          key={'notify_' + source + '_' + client_id}
        >
          <div className="grid m-0 align-items-center">
            <div className="col-8 flex text-xs pl-0">
              <i className="pi pi-user mr-2 text-xs"></i>
              <strong>
                CX Name: {customer_first_name} {customer_last_name}
              </strong>
            </div>
            <div className="col-4 p-0 text-right">
              <Button
                onClick={() =>
                  handleNotificationClickReview(project_id, sms_response_log_id)
                }
                label="Review"
                outlined
                className="text-xs p-1 focus:shadow-none"
              />
              <Button
                onClick={() =>
                  handleNotificationClick(project_id, sms_response_log_id)
                }
                label="View"
                className="text-xs p-1 focus:shadow-none ml-1"
              />
            </div>
          </div>
          <div className="text-xs col-12 p-0 pr-2">
            <i className="pi pi-send mr-2 text-xs"></i>
            {ellipsisString(response_message, 45)}
          </div>
          {subject ? (
            <div className="flex px-3 pb-3 text-xs">
              <div className="col-12 p-0">Subject: {subject}</div>
            </div>
          ) : null}
        </div>
        <div
          className={`${
            index == length - 1
              ? 'block  flex justify-content-center surface-200 p-2'
              : 'hidden'
          }`}
        >
          <Button
            size="small"
            outlined
            severity="info"
            className="py-1 px-2"
            onClick={loadMoreSmsHandler}
            disabled={disabledLoadMore(smsCount) == totalSmsCount || SMSLoading}
          >
            Load more
            {SMSLoading ? (
              <i className="pi pi-spin pi-spinner ml-2 text-10"></i>
            ) : null}
          </Button>
        </div>
      </>
    );
  };

  const handleResyncNotification = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ): void => {
    e.preventDefault();
    const savedSyncTime = localStorage.getItem('syncNotificationTime');

    if (savedSyncTime) {
      const previousSyncTime = new Date(JSON.parse(savedSyncTime));
      const currentTime = new Date();
      const timeDifference = currentTime.getTime() - previousSyncTime.getTime();
      if (timeDifference > 900000) {
        syncNotifications();
      }
    } else {
      localStorage.setItem('syncNotificationTime', JSON.stringify(new Date()));
      syncNotifications();
    }
    setSyncNotification(!syncNotification);
    setTimeout(() => {
      getNotificationData();
      setSyncNotification(false);
    }, 20000);
  };
  return (
    <>
      <Toast className="search-notification" ref={toast} position="top-right" />
      {/* Open TopBar Notification */}
      {hasPullDownMenu && (
        <div className="flex md:shadow-1 md:bg-white border-round-xl lg:p-1 mr-1 xl:mr-2">
          {getInstallerStoreNotesTabs(
            mapInstallerNotifications,
            mapStoreNotificationsList,
            installerNotificationsLength,
            storeCount
          )}
          {getEmailTabs(
            mapEmailNotificationsList,
            emailCount,
            mapCRMEmailNotificationsList(
              crmEmailList,
              handleCRMEmailClick,
              loadMoreCRMEmailHandler,
              disabledLoadMore,
              crmEmailCount,
              totalCRMEmailCount,
              emailLoading
            ),
            totalCRMEmailCount,
            hasEmailVisibilityNotes
          )}
          {getSMSTabs(
            mapSmsNotificationsList,
            smsCount,
            mapCRMSMSNotificationsList(
              crmSMSList,
              handleCRMSMSClick,
              loadMoreCRMSmsHandler,
              disabledLoadMore,
              totalCRMSMSCount,
              SMSLoading,
              crmSMSCount
            ),
            totalCRMSMSCount,
            hasSmsVisibilityNotes
          )}
          {getCustomerCommunicationTabs(
            clientDetails?.is_customer_portal === 1,
            hasVisibilityCustomerChats,
            customerChatsList,
            mapCRMNotes(
              crmNotesList,
              handleCRMNotesClick,
              loadMoreCRMNotesHandler,
              disabledLoadMore,
              totalCRMNotesCount,
              crmNotesCount,
              customerChatsList.isLoading
            ),
            totalCRMNotesCount,
            mapCustomerNotesList(
              customerNotesList,
              handleCustomerNotesClick,
              loadMoreCustomerNotesHandler,
              totalCustomerNotesCount,
              customerNotesCount,
              handleCustomerCommunicationLoading,
              customerChatsList.isLoading
            ),
            totalCustomerNotesCount
          )}
          {(hasInstallerVisibilityNotes ||
            hasStoreVisibilityNotes ||
            hasEmailVisibilityNotes ||
            hasSmsVisibilityNotes ||
            hasVisibilityCustomerChats ||
            hasVisibilityCustomerNotes ||
            checkCRMPermission()) &&
            (syncNotification === true ? (
              <Button
                icon="pi pi-sync pi-spin"
                text
                pt={{
                  badge: {
                    className: 'p-0 absolute ml-4 mb-3',
                  },
                  root: {
                    className: `focus:shadow-none relative p-0`,
                  },
                  icon: {
                    className: 'text-red-400',
                  },
                }}
                tooltip={'Sync in progress'}
                tooltipOptions={{ position: 'bottom' }}
                className="text-sm w-2rem xl:w-3rem p-2 sm:p-1 xl:p-2 hover:bg-red-50"
              />
            ) : (
              <Button
                text
                icon="pi pi-sync"
                pt={{
                  badge: {
                    className: 'p-0 absolute ml-4 mb-3',
                  },
                  root: {
                    className: `focus:shadow-none relative p-2`,
                  },
                  icon: {
                    className: 'text-red-400',
                  },
                }}
                className="text-sm w-2rem xl:w-3rem p-2 sm:p-1 xl:p-2 hover:bg-red-50"
                tooltip="Sync Notifications"
                tooltipOptions={{ position: 'bottom' }}
                onClick={handleResyncNotification}
              />
            ))}
        </div>
      )}
    </>
  );
};

export default HeaderNotifications;
